import React from 'react';
import { useIntl } from 'react-intl';
import { Button, ButtonGroup, ButtonToolbar } from 'reactstrap';

import { APIConfig } from 'src/config';
import { FEATURE_INHIBIT_COMMUNITY_TRADES, FEATURE_INHIBIT_CONTRACTED_TRADES, FEATURE_INHIBIT_NOMINATED_TRADES } from 'src/util/constants';

/**
 * Placeholder component that displays a loading skeleton for the trade list filter controls.
 *
 * Renders non-interactive button groups that mirror the structure of TradeListControls,
 * including direction filters (All, Buy, Sell), trade type filters (Contracted, Peer-to-peer,
 * Community, Retailer default), and a date picker placeholder. Used during initial data loading
 * to maintain consistent layout and provide visual feedback to users.
 * @returns {React.ReactElement} Placeholder skeleton for trade list controls
 */
function TradeListControlsPlaceholder() {
  const intl = useIntl();

  const allLabel = intl.formatMessage({ id: 'trade.trade_list.trade_list_controls_placeholder.all.label', defaultMessage: 'All' });
  const buyLabel = intl.formatMessage({ id: 'trade.trade_list.trade_list_controls_placeholder.buy.label', defaultMessage: 'Buy' });
  const sellLabel = intl.formatMessage({ id: 'trade.trade_list.trade_list_controls_placeholder.sell.label', defaultMessage: 'Sell' });
  const contractedLabel = intl.formatMessage({ id: 'trade.trade_list.trade_list_controls_placeholder.contracted.label', defaultMessage: 'Contracted' });
  const nominatedLabel = intl.formatMessage({ id: 'trade.trade_list.trade_list_controls_placeholder.nominated.label', defaultMessage: 'Peer-to-peer' });
  const communityLabel = intl.formatMessage({ id: 'trade.trade_list.trade_list_controls_placeholder.community.label', defaultMessage: 'Community' });
  const retailerDefaultLabel = intl.formatMessage({ id: 'trade.trade_list.trade_list_controls_placeholder.retailer_default.label', defaultMessage: 'Retailer default' });

  return (
    <div className="trade-history-filters">
      <ButtonToolbar>
        <ButtonGroup className="me-2 mb-2">
          <Button size="sm" className="btn btn-darken trades-history-all">
            {allLabel}
          </Button>
        </ButtonGroup>

        <ButtonGroup className="me-2 mb-2">
          <Button size="sm" className="btn btn-darken trades-history-buy">
            {buyLabel}
          </Button>
          <Button size="sm" className="btn btn-darken trades-history-sell">
            {sellLabel}
          </Button>
        </ButtonGroup>

        <ButtonGroup className="me-2 mb-2">
          {!APIConfig().feature(FEATURE_INHIBIT_CONTRACTED_TRADES) && (
            <Button size="sm" className="btn btn-darken trades-history-contracted">
              {contractedLabel}
            </Button>
          )}
          {!APIConfig().feature(FEATURE_INHIBIT_NOMINATED_TRADES) && (
            <Button size="sm" className="btn btn-darken trades-history-nominated">
              {nominatedLabel}
            </Button>
          )}
          {!APIConfig().feature(FEATURE_INHIBIT_COMMUNITY_TRADES) && (
            <Button size="sm" className="btn btn-darken trades-history-community">
              {communityLabel}
            </Button>
          )}
          <Button size="sm" className="btn btn-darken trades-history-default">
            {retailerDefaultLabel}
          </Button>
        </ButtonGroup>

        <ButtonGroup className="me-2 mb-2 trades-history-date-picker">
          <Button size="sm" className="btn btn-darken">
            <span className="placeholder placeholder-glow bg-darken" style={{ width: '50px' }} />
          </Button>
        </ButtonGroup>
      </ButtonToolbar>
    </div>
  );
}

export default TradeListControlsPlaceholder;
